import React from 'react';
import { StyleSheet, useStyles } from '@rexlabs/styling';
import Box from '@rexlabs/box';
import Email from './icons/v2SmallEmail.svg';
import PhoneSVG from './icons/v2SmallPhone.svg';

const defaultStyles = StyleSheet({
  container: {
    display: 'flex',
    paddingLeft: '40px',
    flexDirection: 'row',
    '> *': {
      marginRight: '24px'
    }
  },
  item: {
    fontSize: 16
  },
  link: {
    textDecoration: 'none',
    ':hover': {
      textDecoration: 'underline',
      opacity: '0.7'
    },
    '*': {
      '-webkit-font-smoothing': 'auto !important'
    }
  }
});

interface Props {
  email: string;
  phone: string;
  itemColor?: string;
  shouldDisplay: boolean;
}
export function Contacts(props: Props) {
  const { itemColor, shouldDisplay, email, phone } = props;
  const s = useStyles(defaultStyles);

  if (!shouldDisplay) return null;

  const itemStyle = {
    ...s.with('item')({
      color: itemColor,
      fill: itemColor,
      stroke: itemColor,
      strokeWidth: 0,
      height: '18px'
    })
  };

  return (
    <>
      {(phone || email) && (
        <Box {...s('container')}>
          {phone && (
            <a
              {...s.with('link')({ textDecorationColor: itemColor })}
              href={`tel:${phone.replace(/[^\d+]/g, '')}`}
            >
              <Box {...itemStyle} flex={1} alignItems={'center'}>
                <Box
                  pr={9}
                  alignItems={'center'}
                  data-testId={'header-phone-contact'}
                >
                  <PhoneSVG />
                </Box>
                <span className='header-contact-span'>{phone}</span>
              </Box>
            </a>
          )}
          {email && (
            <a
              {...s.with('link')({ textDecorationColor: itemColor })}
              href={`mailto:${email}`}
            >
              <Box {...itemStyle} flex={1} alignItems={'center'}>
                <Box
                  pr={9}
                  alignItems={'flex-end'}
                  data-testId={'header-email-contact'}
                >
                  <Email />
                </Box>
                <span className='header-contact-span'>{email}</span>
              </Box>
            </a>
          )}
        </Box>
      )}
    </>
  );
}
